/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Logo from "../../../components/Logo/Logo";

const AuthLoader = () => {
  return (
    <div
      css={css({
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      })}
    >
      <Logo
        color="primary"
        css={css({
          animationName: "pulse",
          animationDuration: "1.5s",
          animationTimingFunction: "linear",
          animationIterationCount: "infinite",
          animationDirection: "alternate",

          "@keyframes pulse": {
            from: {
              transform: "scale(1)",
            },
            to: {
              transform: "scale(1.3)",
            },
          },
        })}
      />
    </div>
  );
};

export default AuthLoader;
